module.exports = __webpack_public_path__ + "static/img/green.628adbd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/GreenIq/green.png
// module id = qxbD
// module chunks = 0